if (!customElements.get("gender-preference-button")) {
  customElements.define(
    "gender-preference-button",
    class GenderPreferenceButton extends HTMLElement {
      constructor() {
        super();

        this.preference = this.dataset.gender;
        this.expireTime = 30;

        this.destinationUrl = this.querySelector("a")?.href;
        this.initializeDefaultPreference();
      }

      connectedCallback() {
        this.addEventListener("click", this.onPreferenceClick.bind(this));
      }

      initializeDefaultPreference() {
        // Only run this once (for the first gender button that loads)
        if (!document.body.classList.contains('gender-preference-initialized')) {
          const existingPreference = this.getCookie('genderPreference');
          
          if (!existingPreference) {
            document.body.classList.add('gender-preference-unisex');
            this.setCookie('genderPreference', 'unisex', this.expireTime);
          } else {
            document.body.classList.add(`gender-preference-${existingPreference}`);
          }
          
          document.body.classList.add('gender-preference-initialized');
        }
      }

      onPreferenceClick(e) {
        e.preventDefault();
        this.setCookie('genderPreference', this.preference, this.expireTime);
        document.body.classList.remove('gender-preference-female', 'gender-preference-male', 'gender-preference-unisex')
        document.body.classList.add(`gender-preference-${this.preference}`);

        if(this.destinationUrl) {
          window.location.href = this.destinationUrl;
        }
      }

      getCookie(cName) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${cName}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      }

      setCookie(cName, cValue, expDays) {
        let date = new Date();
        date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
      }
    }
  );
}
